import { useContext, useState } from 'react';
import { Button } from '../../../../../common/view/button/button/button';
import { Color } from '../../../../../common/view/color/color';
import { EffectContext } from '../../../../../common/view/effect/effect.context';
import { ModalStyle } from '../../../../../common/view/effect/modal/modal.style';
import { MonoIcon } from '../../../../../common/view/icon/mono/mono-icon';
import { ImmerFuncs } from '../../../../../external/immer/immer.funcs';
import { GapY } from '../../../../../foundation/layout/gap-y';
import { TripleX } from '../../../../../foundation/layout/triple-x';
import { EffectWire } from '../../../../core/effect/effect.wire';
import { ProgressEffectDataWire } from '../../../../core/effect/effects/progress/progress-effect-data.wire';

export function ProgressEffectCurrentEditModal({
  effect,
  onOk,
}: {
  effect: EffectWire<ProgressEffectDataWire>;
  onOk?: (effect: EffectWire<ProgressEffectDataWire>) => void;
}) {
  const { modalApi } = useContext(EffectContext);
  const [current, setCurrent] = useState(effect.data.current);

  return (
    <ModalStyle.Container style={{ width: '400px' }}>
      <ModalStyle.Header>
        <TripleX.Container>
          <TripleX.Rest>
            <ModalStyle.Title>{'Update Current Progress'}</ModalStyle.Title>
          </TripleX.Rest>
          <TripleX.Side>
            <Button
              icon={MonoIcon.close}
              size={18}
              color={Color.white7}
              onClick={() => {
                modalApi.pop();
              }}
            />
          </TripleX.Side>
        </TripleX.Container>
      </ModalStyle.Header>
      <ModalStyle.Content>
        <ModalStyle.ContentTitle>Total</ModalStyle.ContentTitle>
        <GapY $gap={'8px'} />
        <ModalStyle.Text>{effect.data.total}</ModalStyle.Text>

        <GapY $gap={'16px'} />

        <ModalStyle.ContentTitle>New Current Progress</ModalStyle.ContentTitle>
        <GapY $gap={'8px'} />
        <ModalStyle.Input type="number" value={current} onChange={(e) => setCurrent(Number(e.target.value))}></ModalStyle.Input>
      </ModalStyle.Content>
      <ModalStyle.Footer>
        <TripleX.Container>
          <TripleX.Rest></TripleX.Rest>
          <TripleX.Side>
            <ModalStyle.FooterButton
              text={'Ok'}
              onClick={() => {
                const newEffect = ImmerFuncs.produce(effect, (draft) => {
                  draft.data.current = current;
                });
                onOk?.(newEffect);
              }}
            ></ModalStyle.FooterButton>
          </TripleX.Side>
        </TripleX.Container>
      </ModalStyle.Footer>
    </ModalStyle.Container>
  );
}
